import React, {Component} from 'react';
import {Badge, Button, Card, Col, DatePicker, Form, Input, InputNumber, Popover, Row, Select, Spin} from 'antd';
import {connect} from "react-redux";
import {fetchMasterFilterData, fetchRelationshipSearchData, getMotorableAssets,} from "../../appRedux/actions";
import {createResource} from '../../appRedux/actions/FuelStatus';
import moment from "moment/moment";
import {message} from "antd/lib/index";

class FuelStatusForm extends Component {

  constructor() {
    super();
    this.id = 0;
    this.state = {
      assetDatas: {},
      selectedDate: "",
      selectedAsset: "",
      selectedFuelType: "",
      fuelTypes: [],
      mileageData: [],
      visible: false,
      stockSelected: 0,
      stockMethod: '',
      assetSaveBtnDisable: []
    };
  }

  componentDidMount() {
    this.props.fetchRelationshipSearchData('', 'Location', 'name');
  };

  componentWillReceiveProps(nextProps) {
    const {fsData} = nextProps;
    const {assetSaveBtnDisable} = this.state;
    assetSaveBtnDisable[fsData.asset] = nextProps.fsData !== this.props.fsData;
    // console.log('xx ', assetSaveBtnDisable);
    this.setState({
      assetSaveBtnDisable
    })
  }

  // handleChange = (type, value) => {
  //   switch (type) {
  //     case 'fuelDate':
  //       this.setState({
  //         selectedFuelDate: moment(value).format('YYYY-MM-DD'),
  //       });
  //       break;
  //   }
  // }

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, _values) => {
      if(err) {
        return console.log(err);
      }
      // console.log(_values);
      this.props.fetchMasterFilterData();
      this.props.getMotorableAssets(_values.location);
      this.setState({
        selectedDate: _values.date
      })
    });
  }

  handleMenuClick = (e, i) => {
    message.info('Click on menu item.' + e.key + ' - ' + i);
    // console.log('click', e);
  }

  handelAssetSave = (e, asset) => {
    e.preventDefault();
    e.stopPropagation();

    const assetData = {...this.state.assetDatas};
    const currentSelectedData = assetData[asset];
    if(currentSelectedData) {

      const currentMotorableAssets = this.props.motorableAssets.filter(ast => ast._id.toString() === asset.toString());

      const {stockMethod, stockReading, mileage} = currentSelectedData;
      let {fuelType, fuelDate} = currentSelectedData;
      if(!fuelType) {
        fuelType = currentMotorableAssets[0].fuelType._id
      }
      if(!fuelDate) {
        fuelDate = this.state.selectedDate
      }

      if(fuelDate && fuelType && stockMethod && stockReading && mileage) {
        const mileageData = [];
        for (let key in mileage) {
          mileageData.push({'unit': key, 'reading': mileage[key]});
        }
        const payload = {
          date: fuelDate,
          asset,
          typeOfFuel: fuelType,
          mileage: mileageData,
          stockReading,
          stockMethod,
        };
        // console.log(payload);
        this.props.createResource(payload, this.props.motorableAssets);
      } else
        message.error('Selected Asset Data is invalid');
    } else {
      message.error('Selected Asset Data is invalid');
    }

  }

  handleChange = (asset, type, value, mileageName) => {
    const assetDatas = {...this.state.assetDatas};
    const currentAssetData = assetDatas[asset];

    let rowData = {};
    if(!currentAssetData)
      rowData[asset] = {};
    else
      rowData[asset] = currentAssetData;

    switch (type) {
      case 'fuelDate':
        rowData[asset][type] = moment(value).format('YYYY-MM-DD');
        this.setState({
          assetDatas: {...assetDatas, ...rowData},
        });
        break;
      case 'fuelType':
        rowData[asset][type] = value;
        this.setState({
          assetDatas: {...assetDatas, ...rowData},
        });
        break;
      case 'stockMethod':
        rowData[asset][type] = value;
        this.setState({
          assetDatas: {...assetDatas, ...rowData},
        });
        break;
      case 'stockReading':
        rowData[asset][type] = value;
        this.setState({
          assetDatas: {...assetDatas, ...rowData},
        });
        break;
      case 'mileage':
        if(mileageName) {
          const mileageUnit = rowData[asset][type] ? rowData[asset][type] : {};
          //delete mileageUnit[mileageName];
          mileageUnit[mileageName] = value.target.value;
          rowData[asset][type] = mileageUnit;
          this.setState({
            assetDatas: {...assetDatas, ...rowData},
          });
        }
        break;
      default:
    }
  };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {
      data, loading, filters, title, resource, form,
      locationData, motorableAssets, filterData
    } = this.props;
    const {fuelTypes, meterUnits, stockMethods} = filterData;
    // console.log(this.state.assetSaveBtnDisable);
    return (
      <Spin spinning={loading}>
        <Card
          className={`gx-card-metrics`}
          // title={`${sanitizeFieldName(resource)} ${title}`}
        >
          <Form onSubmit={this.handleSubmit}
                className="ant-advanced-search-form"
                layout="inline"
                labelAlign="left">
            <Row>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item key={'location'} label={'Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`location`, {
                    rules: [{required: true, message: `Location is required!`}],
                  })(<Select
                    showSearch
                    showArrow
                    // onChange={value => this.handleChange('location', value)}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Location`}
                  >
                    <Select.Option key={''} disabled={true}
                                   value={''}>Select</Select.Option>

                    {(locationData || []).map(item =>
                      <Select.Option key={item._id}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item key={'date'} label={'Date'} style={{width: '100%'}}>
                  {getFieldDecorator(`date`, {
                    rules: [{required: true, message: `Date is required!`}],
                  })
                  (<DatePicker placeholder={'Select Date'}/>)
                  }
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item key={"button"} style={{width: "100%", top: 25}}>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    OK
                  </Button>
                </Form.Item>
              </Col>
            </Row>

          </Form>
        </Card>
        <Card>
          {
            motorableAssets && motorableAssets.length > 0 ? motorableAssets.map((_item, index) => (
              <Row gutter={8} style={{marginBottom: 10}} key={index}>

                <Col xs={24} sm={24} md={4} lg={2} xl={2}>{_item.assetCode}</Col>
                <Col xs={24} sm={24} md={6} lg={3} xl={3}>
                  <Select style={{width: '100%'}} onChange={value => this.handleChange(_item._id, 'fuelType', value)}
                          placeholder="Fuel Type" defaultValue={_item.fuelType._id ? _item.fuelType._id : ''}
                          disabled={_item.fuelType._id ? true : false}>
                    <Select.Option value="">-- Select --</Select.Option>
                    {
                      (fuelTypes && fuelTypes.data && fuelTypes.data.count > 0) ? fuelTypes.data.data.map(ft =>
                        <Select.Option key={ft._id}
                                       value={ft._id}>{ft.name}</Select.Option>) : null
                    }
                  </Select>
                </Col>
                {/*<Col xs={24} sm={24} md={8} lg={3} xl={3}>*/}
                {/*<DatePicker placeholder={'Stock Date'} defaultValue={this.state.selectedDate} disabled={false}/>*/}
                {/*</Col>*/}
                <Col xs={24} sm={24} md={8} lg={4} xl={4}>
                  <Select style={{width: '100%'}} placeholder="Start or End"
                          onChange={value => this.handleChange(_item._id, 'startEndDayStock', value)}>
                    <Select.Option value="">-- Select --</Select.Option>
                    <Select.Option value="0">EOD Stock</Select.Option>
                    <Select.Option value="1">SOD Stock</Select.Option>
                  </Select>
                </Col>
                <Col xs={24} sm={24} md={6} lg={4} xl={4}>
                  <Select style={{width: '100%'}} placeholder="Stock method"
                          onChange={value => this.handleChange(_item._id, 'stockMethod', value)}>
                    <Select.Option value="">-- Select --</Select.Option>
                    {
                      (stockMethods && stockMethods.data && stockMethods.data.count > 0) ? stockMethods.data.data.map(item =>
                        <Select.Option key={item._id}
                                       value={item._id}>{item.name}</Select.Option>) : null
                    }
                  </Select>
                </Col>
                <Col xs={24} sm={24} md={6} lg={3} xl={3}>
                  <InputNumber placeholder="Stock" style={{width: '100%'}}
                               onChange={value => this.handleChange(_item._id, 'stockReading', value)}/></Col>
                <Col xs={24} sm={24} md={6} lg={3} xl={3}>
                  <Popover content={
                    <div>
                      {
                        (meterUnits && meterUnits.data && meterUnits.data.count > 0) ? meterUnits.data.data.map(item =>
                          <div style={{marginBottom: 16}}>
                            <Input addonBefore={item.name} type="number" key={`${item.name}-${index}`}
                                   onChange={value => this.handleChange(_item._id, 'mileage', value, item._id)}/>
                          </div>) : null
                      }
                    </div>
                  } title="Add Meter Reading" trigger="click">
                    <Button type="dashed" style={{borderColor: 'green'}}>
                      <Badge status={'processing'} color={'green'} text={'Meter'}/>
                    </Button>

                  </Popover>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    onClick={(e) => this.handelAssetSave(e, _item._id)}
                    disabled={this.state.assetSaveBtnDisable[_item._id] ? true : false}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            )) : null
          }
        </Card>
      </Spin>
    );
  }
}

const mapStateToProps = ({auth, fuel, commonData, fuelStatus}) => {
  return {
    locationData: commonData.relationshipSearch,
    motorableAssets: fuel.assets,
    filterData: fuel.filters,
    fsData: fuelStatus.resource,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchRelationshipSearchData,
    getMotorableAssets,
    fetchMasterFilterData,
    createResource
  };
}

const FuelStatusAntForm = Form.create({name: 'fuel-status'})(FuelStatusForm);
export default connect(mapStateToProps, mapDispatchToProps())(FuelStatusAntForm);
